<textarea
  nz-input
  [nzAutosize]="props.autosize"
  [rows]="props.rows ? props.rows : 2"
  [formControl]="formControl"
  [placeholder]="props.placeholder"
  [formlyAttributes]="field"></textarea>
